import { StyleSheet, UnistylesRuntime } from "react-native-unistyles";

import CustomPlatform from "$src/core/utils/platform/platform";

const stylesheet = StyleSheet.create(({ spacing }) => ({
  section: {
    flexDirection: "column",
    marginBottom: {
      xs: spacing(6),
      lg: spacing(14),
    },
    gap: {
      xs: spacing(2),
      lg: spacing(4),
    },
  },
  sectionHeader: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingTop: CustomPlatform.select({
      tv: spacing(2),
      default: spacing(4),
    }),
  },
  sectionHeaderBrandLogo: {
    height: spacing(12),
    aspectRatio: 4 / 3,
  },
  sectionLane: {
    paddingBottom: CustomPlatform.select({
      tv: spacing(4),
      default: spacing(6),
    }),
  },
  sectionLaneContent: {
    gap: {
      xs: spacing(3),
      md: spacing(5),
    },
  },
  brandImageContainer: {
    position: "absolute",
    top: "-5%",
    left: 0,
    bottom: 0,
    height: "105%",
    display: {
      xs: "none",
      lg: "flex",
    },
  },
  brandImage: {
    height: "100%",
    aspectRatio: 1,
  },
}));

const initialTheme = UnistylesRuntime.getTheme();

export const IMAGE_DIMENSIONS = {
  brandLogo: [
    {
      width: initialTheme.spacing(12),
      height: initialTheme.spacing(12) * (4 / 3),
    }, // for 4:3
    {
      width: initialTheme.spacing(16),
      height: initialTheme.spacing(16) * (4 / 3),
    }, // for 4:3
    {
      width: initialTheme.spacing(20),
      height: initialTheme.spacing(20) * (4 / 3),
    }, // for 4:3
  ],
};

export default stylesheet;
